import { DriveFile, OrganizationMember } from '@prisma/client'
import { message } from 'antd'
import { useEffect, useState } from 'react'
import { Toolbox } from '~/plugins/toolbox/shared'
import { useSdk } from './useSdk'

type Options = {
  organizationMember: OrganizationMember
  driveFileId: string
}

export const useDriveFile = ({ driveFileId, organizationMember }: Options) => {
  const sdk = useSdk({ organizationMember })
  const [driveFile, setDriveFile] = useState<DriveFile>()
  const [isLoading, setIsLoading] = useState(false)

  const refresh = async () => {
    try {
      setIsLoading(true)
      const driveFileFound = await sdk.findOneFile({ driveFileId })
      setDriveFile(driveFileFound)
    } catch (error) {
      message.error(`Something went wrong`)
      console.error('Unknown Error', error)
    } finally {
      setIsLoading(false)
    }
  }

  const updateDriveFile = async (driveFileUpdated: Partial<DriveFile>) => {
    try {
      await sdk.updateOneFile({
        driveFile: driveFileUpdated,
      })

      await refresh()
    } catch (error) {
      message.error(`Something went wrong`)
      console.error('Unknown Error', error)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    if (Toolbox.Utility.isDefined(driveFileId)) {
      refresh()
    }
  }, [driveFileId])

  return {
    driveFile,
    refetch: refresh,
    updateDriveFile,
    isLoading,
  }
}
